<template>
  <el-dialog :visible.sync="show" width="800px">
    <template #title>
      <span style="font-size: 14px;">{{ name }}</span>
    </template>
    <div class="cf" style="margin-bottom: 10px;">
      <div class="fl" style="font-size: 16px; display: flex; align-items: center;">
        <el-input v-model="userName" size="mini" placeholder="输入用户" style="margin-right: 10px; width: 200px" clearable
          @change="init"></el-input>
        <el-input v-model="userPhone" size="mini" placeholder="输入手机号" style="margin-right: 10px; width: 200px" clearable
          @change="init"></el-input>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="400px" v-loading="loading"
      highlight-current-row>
      <template #empty>
        <el-empty></el-empty>
      </template>
      <el-table-column prop="userName" label='用户' mniWidth="100" align="center"></el-table-column>
      <el-table-column prop="userPhone" label='手机号' minWidth="100" align="center"></el-table-column>
      <el-table-column prop="createTime" label='记录时间' width="140" align="center"></el-table-column>
      <el-table-column prop="profitDistributionStatus" label='分账状态' width="140" align="center" v-if="type !== '1'">
        <template #default="scope">
          <el-select v-model="scope.row.profitDistributionStatus" size="mini" placeholder="请选择分账状态"
            @change="changeProfitDistributionStatus(scope.row)">
            <el-option label="已分账" value="1"></el-option>
            <el-option label="未分账" value="0"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="allocationTime" label='分账时间' width="140" align="center"
        v-if="type !== '1'"></el-table-column>
    </el-table>
    <div style="text-align: left; padding: 10px 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
        :page-sizes="[20, 50, 80, 100, 200]" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
        :total="page.total" background>
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      show: false,
      data: [],
      loading: false,
      parentData: {},
      userName: '',
      userPhone: '',
      type: '',
      name: '',
      page: {
        total: 0,
        size: 20,
        current: 1
      },
    }
  },
  methods: {
    display(event) {
      this.parentData = event.data
      this.type = event.type
      this.data = []
      const title = `【${this.parentData.laboratoryName}】【${this.parentData.coalShopName}】【${this.parentData.coalProductName}】【${this.parentData.submissionTime}】`
      this.name = this.type === '1' ? title + '浏览记录' : title + '购买记录'
      this.show = true
      this.page = {
        total: 0,
        size: 20,
        current: 1
      }
      this.init()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.init()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.init()
    },
    init() {
      this.loading = true
      const params = {
        userName: this.userName || undefined,
        userPhone: this.userPhone || undefined,
        type: this.type,
        reportId: this.parentData.id,
        pageSize: this.page.size,
        pageNum: this.page.current
      }
      this.$axios.post('/laboratory/report_release/queryReportOrderUserPage', params).then(res => {
        this.data = res.data.data.list
        this.page.total = res.data.data.total
        this.loading = false
      }).finally(() => {
        this.loading = false
      })
    },
    changeProfitDistributionStatus(row) {
      const params = {
        id: row.id,
        profitDistributionStatus: row.profitDistributionStatus
      }
      this.$axios.post('/laboratory/report_order/profitDistribution', params).then(res => {
        this.$message.success({ showClose: true, message: `${row.profitDistributionStatus === '1' ? '分账成功' : '取消分账'}` })
        this.init()
        this.$emit('init')
      })
    }
  }
}
</script>
